import React from 'react'
import { Box } from '@mui/material'

function ButtonBlock({id,type,properties}) {
  return (
    <Box
            sx={{
              textAlign: properties.textAlign || 'left',
              padding:  `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
              margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
              backgroundColor: properties.backgroundColor || '#007bff',
            }}
          >
            <Box
              component="a"
              href={properties.href || '#'}
              sx={{
                display: properties.display || 'block',
                backgroundColor: properties.buttonbackgroundColor || '#007bff',
                color: properties.color || '#ffffff',
                padding:  `${properties.buttonpadding.top}px ${properties.buttonpadding.right}px ${properties.buttonpadding.bottom}px ${properties.buttonpadding.left}px`,
                margin:  `${properties.buttonmargin.top}px ${properties.buttonmargin.right}px ${properties.buttonmargin.bottom}px ${properties.buttonmargin.left}px`,
                borderRadius: properties.buttonborderRadius || '4px',
                fontSize: properties.fontSize || '16px',
                fontWeight: properties.fontWeight || 'bold',
                textDecoration: 'none',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.9
                }
              }}
            >
              {properties.text || 'Click Me'}
            </Box>
          </Box>
  )
}

export default ButtonBlock